// Approved website FAQ copy from Trilloan_Website_FAQs_2026.docx.
export const faqCategories = [
  {
    id: "account-verification",
    title: "Account & Verification",
    copy: "Identity checks, account limits, and verification status.",
    questions: [
      {
        question: "Why do I need to verify my identity?",
        answer:
          "Identity verification protects your account, prevents fraud, and unlocks more features.",
      },
      {
        question: "Can I have multiple trilLOAN accounts?",
        answer: "No. Each user may only register one account.",
      },
      {
        question: "How do I verify my account?",
        answer:
          "Go to My Account > Upgrade Now, complete the steps, and submit your application. Approval usually takes 24–48 hours.",
      },
      {
        question: "Why was my verification rejected?",
        answer:
          "This may be due to incorrect information, an expired ID, unclear photos, or incomplete requirements.",
      },
    ],
  },
  {
    id: "account-management",
    title: "Account Management",
    copy: "Closing or reactivating your trilLOAN account.",
    questions: [
      {
        question: "How do I close my account?",
        answer:
          "Go to Settings > Close My Account. Your account must have no active loans.",
      },
      {
        question: "Can I reactivate my account?",
        answer:
          "Yes. You may request reactivation within 30 days through Customer Support.",
      },
    ],
  },
  {
    id: "security",
    title: "Security",
    copy: "Keep your account protected and regain access safely.",
    questions: [
      {
        question: "My account is locked. What should I do?",
        answer:
          "Use 2-Step Verification to unlock your account. If you still can't access it, contact Customer Support.",
      },
      {
        question: "Why was my account permanently suspended?",
        answer:
          "Accounts may be suspended for violating our Terms of Service.",
      },
      {
        question: "How do I change or reset my MPIN?",
        answer:
          "Reset it from the login screen or change it anytime under Settings > Change MPIN.",
      },
      {
        question: "How do I change my security questions?",
        answer:
          "Go to Settings > Change Security Questions and update your answers.",
      },
    ],
  },
  {
    id: "support",
    title: "Support",
    copy: "Get in touch when you need help from the trilLOAN team.",
    questions: [
      {
        question: "Need more help?",
        answer:
          "Contact us through the trilLOAN app, Live Chat, or email corporate@trilloan.com.",
      },
    ],
  },
];
